export enum FEATURE_FLAGS_V5 {
  MODULE_HANA_AI = 'MODULE_HANA_AI',
  ACTIVE_HANA_AI = 'ACTIVE_HANA_AI',
  ENABLE_HANA_END_USER = 'ENABLE_HANA_END_USER',
  CONTENT_CREATE_TRACK_REDESIGN = 'CONTENT_CREATE_TRACK_REDESIGN',
  WIDGETS_DASHBOARD = 'WIDGETS_DASHBOARD',

  ENABLE_CUSTOM_NOTIFICATION_EMAILS = 'ENABLE_CUSTOM_NOTIFICATION_EMAILS',
  LEARNING_CUSTOM_NOTIFICATION_COURSES = 'LEARNING_CUSTOM_NOTIFICATION_COURSES',
  LEARNING_CUSTOM_NOTIFICATION_LIVE_SESSIONS = 'LEARNING_CUSTOM_NOTIFICATION_LIVE_SESSIONS',

  LEARNING_AUTOMATION_COURSES = 'LEARNING_AUTOMATION_COURSES',
  NEW_SIDEBAR_LAYOUT = 'NEW_SIDEBAR_LAYOUT',
  SIDEBAR_V2 = 'SIDEBAR_V2',
  ENABLED_ALL_COURSES_DOWNLOAD_DC4 = 'ENABLED_ALL_COURSES_DOWNLOAD_DC4',
  ENABLE_BLOCKING_COURSE_PLAYER_PROGRESS = 'ENABLE_BLOCKING_COURSE_PLAYER_PROGRESS',
  LEARNING_GENERAL_CERTIFICATES = 'LEARNING_GENERAL_CERTIFICATES',
  LEARNING_AUTOMATED_TRACK_TASKS = 'LEARNING_AUTOMATED_TRACK_TASKS',
  //Migration KH v2
  KNOWLEDGE_HUB_ADMIN_CATALOG_MANAGE_V2 = 'KNOWLEDGE_HUB_ADMIN_CATALOG_MANAGE_V2',
  KNOWLEDGE_HUB_ADMIN_CATEGORY_CONFIG_V2 = 'KNOWLEDGE_HUB_ADMIN_CATEGORY_CONFIG_V2',
  KNOWLEDGE_HUB_ADMIN_ELEVATE_V2 = 'KNOWLEDGE_HUB_ADMIN_ELEVATE_V2',
  LEARNING_SELECT_ALL_COURSES_REPORT_DC3_DC4 = 'LEARNING_SELECT_ALL_COURSES_REPORT_DC3_DC4',
  KNOWLEDGE_HUB_ADMIN_DOCUMENTS_V2 = 'KNOWLEDGE_HUB_ADMIN_DOCUMENTS_V2',
  ENABLE_CHILDREN_ORGANIZATION_MANAGEMENT = 'ENABLE_CHILDREN_ORGANIZATION_MANAGEMENT',
}

export const FEATURE_FLAGS_V5_KEYS = Object.values(FEATURE_FLAGS_V5);
